import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'catalogos/motivo-de-baja-de-nombramiento';

/**
 * GET Motivos de baja
 * @returns {Promise<object[]>}
 */
export const getMotivosBajaNombramientos = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Motivo de baja
 * @returns {Promise<object[]>}
 */
export const getMotivoBajaNombramiento = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Crear Motivos de baja
 * @param {object} data
 * @returns {Promise<object>}
 */
export const postMotivoBajaNombramiento = async (data) => {
  try {
    const response = await API.post(baseURI, data);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * PATCH Editar Motivos de baja
 * @param {object} data
 * @param {number} id
 * @returns {Promise<object>}
 */
export const patchMotivoBajaNombramiento = async (id, data) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, data);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * DELETE Motivos de baja
 * @param {number} id
 * @returns {Promise<object>}
 */
export const deleteMotivoBajaNombramiento = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
  }
  return null;
};
